module.exports = __webpack_public_path__ + "static/media/5gnationwide-thumbnail.3a19751f.png";